import { UserDetailResp } from './userDetailResp';

/*
 * 公共常量
 * @author miqiang
 * @date 2019-10-25
 */
export class PublicParams {

    /**
     * 日期格式
     */
    static dateFormate = 'YYYY-MM-DD';

    /**
     * 日期+时间格式
     */
    static dateTimeFormate = 'YYYY-MM-DD hh:mm:ss';

    /**
     * 缓存用户信息的key
     */
    static cacheUserName = 'userCache';

    /**
     * 管理员角色
     */
    static admin_role = '管理员';

    /**
     * 教材管理员角色
     */
    static librarian_role = '教材管理员';


    /**
     * 字符串分隔符
     */
    static string_split_str = ',';

    /**
     * 普通输入框默认最大长度
     */
    static clumn_lenth = 50;

    /**
     * 描述输入框默认最大长度
     */
    static description_lenth = 120;

    /**
     * 用户密码加密key
     */
    static salt = "Y2ZkOTg3NDU2MTIzMEFCQw==";

    /**
     * 第三方token请求header中的key
     */
    static thirdParam = "thirdParam";

    /**
     * 第三方token请求header中的value
     */
    static thirdValue = "thirdToken";

    /**
     * 路由路径url
     */
    static routeUrls: Array<string> = ["feather/", "jczy/", "tzjrw/", "tzgl/", "pyfa/"
        , "jxap/", "autocourse/", "xkgl/", "jcgl/", "jxyx/", "kwgl/", "autoexam/",
        "cjgl/", "pjgl/", "bygl/", "workflow/", "third/", "file/"];

    static bytkId = '402884a3686f55020168741333440003';
}
